export default __webpack_public_path__ + "static/media/logo-light.7bab7cb0.png";